import { Component, Fragment } from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import { Router } from 'react-router-dom';
import { scrollToTop } from '../myAccount/ui/scrollPanel/ScrollHelper';
import { configureHistory, getHistory, setURLPath } from './HistoryProvider';
import {
    CHANGE_ROUTER,
    LEAVING_ROUTER,
    REPLACE_ROUTER,
    SET_HISTORY
} from './IwRouter.actions';
import { buildEvent } from './LocationHelper';

const mapStateToProps = ({ history }) => history;

const mapDispatchToProps = (dispatch) => ({
    setHistory: (history) => dispatch({ type: SET_HISTORY, history }),
    leavingRouter: (event) => dispatch({ type: LEAVING_ROUTER, ...event }),
    changeRouter: (event) => dispatch({ type: CHANGE_ROUTER, ...event }),
    replaceRouter: (event) => dispatch({ type: REPLACE_ROUTER, ...event })
});

class IwRouter extends Component {
    UNSAFE_componentWillMount() {
        const {
            changeRouter,
            setHistory,
            disableFirstRouterChange,
            initialURL
        } = this.props;

        if (initialURL) {
            setURLPath(initialURL);
        }

        const history = configureHistory();
        setHistory(history);
        changeRouter(buildEvent(history, disableFirstRouterChange));

        history.block((location, action) => {
            this.props.leavingRouter({
                from: history.location,
                to: location,
                action
            });
        });

        history.listen((location, action) => {
            if (_.get(location, 'state.keepScrollPosition') !== true) {
                scrollToTop();
            }

            if (
                _.get(location, 'state.stopEventPropagation') !== true ||
                action === 'POP'
            ) {
                this.props.changeRouter(buildEvent({ location, action }));
            } else {
                this.props.replaceRouter(buildEvent({ location, action }));
            }
        });
    }

    render() {
        const { children } = this.props;

        return (
            <Router history={getHistory()}>
                <>{children}</>
            </Router>
        );
    }
}

// eslint-disable-next-line import/no-default-export
export default connect(mapStateToProps, mapDispatchToProps)(IwRouter);
